import styled from "styled-components";

import { SatisfactionSurveyResultContainer } from "../../../../../organisms/SatisfactionSurvey/components/molecules/SatisfactionSurveyResult/styles";

export const LessonVideoPlayerButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;

  &:has(${SatisfactionSurveyResultContainer}) {
    justify-content: space-between;

    @media (max-width: 1440px) {
      flex-direction: column-reverse;
    }
  }

  .satisfaction-loader {
    flex: 1;
  }

  .right-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-end;

    @media (max-width: 600px) {
      width: 100%;
      flex-direction: column-reverse;

      button {
        width: 100%;
        justify-content: center;
      }
    }
  }
`;
